import React, { useState, useEffect, useRef, useCallback } from "react";
import * as SignalR from "@aspnet/signalr";
import { url } from "../constants/config";
import { useSelector } from "react-redux";

const useChat = roomId => {
  const connection = useRef(null);

  const [status, setStatus] = useState("");

  const [chatSessions, setChatSessions] = useState([]);

  const [messages, setMessages] = useState([]);

  const { authToken } = useSelector(state => state.auth);

  useEffect(() => {
    console.log("authToken: ", authToken);
    if (authToken !== "") {
      console.log("authToken passed: ", authToken);
      setStatus("Connecting");

      let hubConnection = new SignalR.HubConnectionBuilder()
        .withUrl(url + "/chatHub", { accessTokenFactory: () => authToken })
        .configureLogging(SignalR.LogLevel.Information)
        .build();

      hubConnection
        .start()
        .then(function() {
          connection.current = hubConnection;
          setStatus("Connected");

          hubConnection.on("ExistingUsers", users => {
            setChatSessions(users);
          });

          //existing messages?

          hubConnection.on("NewMessage", (user, message) => {
            setMessages(messages => [...messages, { user, message }]);
          });

          hubConnection.on("NewUser", ({ connectionId, identity }) => {
            setChatSessions(users => [
              ...users,
              { connectionId: connectionId, identity: identity }
            ]);
            pushMessage(identity.name + " joined the room");
          });

          hubConnection.on("RemoveUser", connectionId => {
            setChatSessions(users =>
              users.filter(user => user.connectionId !== connectionId)
            );
          });

          hubConnection.invoke("JoinRoom", roomId);
        })
        .catch(error => {
          setStatus("Error");
        });

      hubConnection.onclose(error => {
        setStatus("Closed");
      });
    }

    return () => {
      setStatus("Stopping");
      if (connection && connection.current) connection.current.stop();
    };
  }, [authToken, roomId]);

  function pushMessage(message) {
    setMessages(messages => [
      ...messages,
      {
        user: {
          id: 0,
          name: ""
        },
        message: message
      }
    ]);
  }

  async function sendMessage(message) {
    connection.current.invoke("SendMessage", message);
  }
  const chatStatus = status;

  return [{ chatStatus, messages, chatSessions }, sendMessage];
};

export default useChat;
